import { render, staticRenderFns } from "./CalendarKyc.vue?vue&type=template&id=10cc684a&scoped=true"
import script from "./CalendarKyc.vue?vue&type=script&lang=js"
export * from "./CalendarKyc.vue?vue&type=script&lang=js"
import style0 from "./CalendarKyc.vue?vue&type=style&index=0&id=10cc684a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc684a",
  null
  
)

export default component.exports